import Component from '../inherited/Component'
import simpleParallax from 'simple-parallax-js';

export default class AnimationsParallax extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._targetImages = this._elem.querySelectorAll('img')
  }

  mount () {
    new simpleParallax(this._targetImages, this._options)
  }
}